import React from 'react';
import { useField } from 'formik';

// components
import { TextInput } from 'components/inputs/TextInput';

export interface CustomTextProps {
  name: string;
  id?: string;
  label?: string;
  placeholder?: string;
  width?: number;
  type: 'text' | 'email';
  shouldBeTouched?: boolean;
  onFocus?: () => void;
}

export const TextField = (props: CustomTextProps) => {
  const [field, meta] = useField(props.name);
  const isError = props.shouldBeTouched
    ? meta.touched && meta.error
    : meta.error;

  return <TextInput {...props} {...field} isError={!!isError} />;
};
